import { cn } from "@/lib/utils";
import { Loader2 } from "lucide-react";
import { SpinnerColor, SpinnerProps, SpinnerSize } from "./types";

const sizeMap: Record<SpinnerSize, number> = {
  xs: 16,
  sm: 20,
  md: 24,
  lg: 32,
  xl: 48,
};

const colorMap: Record<SpinnerColor, string> = {
  primary: "text-blue-600",
  secondary: "text-gray-600",
  success: "text-green-600",
  warning: "text-amber-500",
  destructive: "text-red-600",
  info: "text-sky-500",
  white: "text-white",
};

export const Spinner = ({ size = "md", className = "", color = "primary" }: SpinnerProps) => {
  const pixelSize = typeof size === "number" ? size : sizeMap[size];
  const colorClass = colorMap[color as SpinnerColor] || color;

  return (
    <div className={cn("flex items-center justify-center", className)} role="status" aria-live="polite">
      <Loader2 className={cn("animate-spin", colorClass)} size={pixelSize} />
    </div>
  );
};

export const PageSpinner = ({ color = "primary" }: { color?: SpinnerColor }) => (
  <div className="flex h-screen w-full items-center justify-center" role="status" aria-live="polite">
    <Spinner size="lg" color={color} className="justify-self-center" />
  </div>
);

export const ButtonSpinner = ({
  size = "sm",
  color = "white",
  className = "",
}: {
  size?: SpinnerSize | number;
  color?: SpinnerColor;
  className?: string;
}) => {
  const pixelSize = typeof size === "number" ? size : sizeMap[size];
  const colorClass = colorMap[color as SpinnerColor] || colorMap.white;

  return (
    <Loader2 className={cn("animate-spin", colorClass, className)} size={pixelSize} role="status" aria-live="polite" />
  );
};
